import { render, staticRenderFns } from "./ArticleTag.vue?vue&type=template&id=41cd8d83&scoped=true&"
import script from "./ArticleTag.vue?vue&type=script&lang=js&"
export * from "./ArticleTag.vue?vue&type=script&lang=js&"
import style0 from "./ArticleTag.vue?vue&type=style&index=0&id=41cd8d83&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41cd8d83",
  null
  
)

export default component.exports